module.exports = __webpack_public_path__ + "img/SuccessIcon.484a20a8.svg";